import { MIN_RETENTION_LIMIT, MAX_RETENTION_LIMIT } from '../services/Migration/updateSnapshotRetentionService';

export interface RetentionValidationResult {
    valid: boolean;
    /** Present only when `valid` is false. */
    error?: string;
}

/**
 * Validates a candidate snapshot-retention value against the backend contract
 * (integer between {@link MIN_RETENTION_LIMIT} and {@link MAX_RETENTION_LIMIT}
 * inclusive). Pure so it can be unit tested and reused by the editor UI.
 */
export function validateRetentionLimit(value: number): RetentionValidationResult {
    if (!Number.isFinite(value) || !Number.isInteger(value)) {
        return { valid: false, error: 'Enter a whole number.' };
    }
    if (value < MIN_RETENTION_LIMIT || value > MAX_RETENTION_LIMIT) {
        return {
            valid: false,
            error: `Enter a value between ${MIN_RETENTION_LIMIT} and ${MAX_RETENTION_LIMIT}.`
        };
    }
    return { valid: true };
}

/**
 * True when a proposed retention limit would immediately drop existing history
 * entries (the backend trims oldest-first on lowering the limit). Used to warn
 * the user before they confirm a destructive reduction.
 */
export function retentionReductionDropsHistory(
    proposedLimit: number,
    currentHistoryCount: number
): boolean {
    return proposedLimit < currentHistoryCount;
}
